<div class="container-fluid g-0 m-0 p-4 ps-5">
  <div class="d-flex align-items-center justify-content-between mb-0">
    <div>
      <h2 class="pb-2 m-0 title">
        {{ "ANALYTICS_TITLE" | translate }}
      </h2>
      <h6 class="subtitle">
        {{ "ANALYTIC_SUBTITLE" | translate }}
      </h6>
    </div>

    <!-- Region & Area filters -->
    <div class="d-flex align-items-center gap-3">
      <app-dropdown-filter [selectedValue]="selectedRegion" [title]="'REGION'" [items]="regions"
        (close)="onRegionChange($event)"></app-dropdown-filter>
      <app-dropdown-filter [selectedValue]="selectedArea" [title]="'DEVICESETUP_AREA'" [items]="areas"
        (close)="onAreaChange($event)"></app-dropdown-filter>
    </div>
  </div>
  <div class="row-md-12 d-flex pt-4">
    <!-- Left part -->
    <div class="col-md-7 pe-4">
      <div class="row gap-3">
        <!-- Upper left block -->
        <div class="col-12 member-info p-3 pb-1">
          <div class="row g-0 pb-3 ps-3">
            <div class="col">
              <span class="container-title">{{
                "ANALYTIC_GRIDNODES" | translate
                }}</span>
            </div>
          </div>
          <div class="row g-0 p-2 gap-3 pe-1 ps-0">
            <div class="col-4 flex-column d-flex justify-content-center align-items-center">
              <div class="row g-0 pb-3">
                <span class="row g-0 d-flex justify-content-center events-label">{{ "ALLASSETS" | translate }}</span>
                <span class="row g-0 d-flex justify-content-center larger-title">{{ allAssets | number }}</span>
              </div>
              <div class="d-flex justify-content-center">
                <div class="pie-container">
                  <canvas id="pie" class="small-chart"></canvas>
                </div>
              </div>
            </div>
            <div class="col g-0 assets-color border-allover">
              <div class="row g-0 ps-4 pe-3 p-3 border-bottom justify-content-between">
                <div class="col-md-3 d-flex">
                  <span class="events-label">{{ "ASSETS" | translate }}</span>
                </div>
                <div class="col-md-7 d-flex justify-content-end">
                  <span class="events-label">{{
                    "DEVICECONNECTIONSTATUS" | translate
                    }}</span>
                </div>
              </div>
              <div class="row g-0 ps-4 pe-3 p-1 border-bottom " *ngFor="let item of analyticsData; let i = index">
                <div class="col-md-4 d-flex">
                  <div class="col-auto pe-3 g-0 d-flex justify-content-start align-items-center">
                    <span class="circle" [ngStyle]="{
                    'background-color':
                      chart.data.datasets[0].backgroundColor[i],
                  }"></span>
                  </div>
                  <div class="col g-0">
                    <div class="row g-0">
                      <span class="events-label">{{ item.assetTypeName }}</span>
                    </div>
                    <div class="row g-0">
                      <span class="item-info" [ngStyle]="{ color: chart.data.datasets[0] }">{{ item.off! + item.on!
                        }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-8 d-flex justify-content-end gap-2 align-items-center">
                  <div class="col-auto d-flex on mt-1 mb-1">
                    <span class="on-left d-flex align-items-center ps-2 pe-2">{{
                      "ON" | translate
                      }}</span>
                    <span class="d-flex align-items-center ps-3 pe-3">{{
                      item.on | number
                      }}</span>
                  </div>
                  <div class="col-auto d-flex off mt-1 mb-1">
                    <span class="off-left d-flex align-items-center ps-2 pe-2">{{
                      "OFF" | translate
                      }}</span>
                    <span class="d-flex align-items-center ps-3 pe-3">{{
                      item.off | number
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Lower left block -->
        <div class="col-12 member-info p-3 pb-1">
          <div class="row g-0 pb-2 ps-3">
            <div class="col">
              <span class="container-title">{{
                "ANALYTIC_REMOTECOMMAND" | translate
                }}</span>
            </div>
            <div class="col d-flex justify-content-end">
              <app-date-filter (close)="onDateFilterCommand($event)"></app-date-filter>
            </div>
          </div>
          <div class="row g-0 p-2 gap-3 pe-1 ps-0">
            <div class="col-4 d-flex justify-content-center align-items-center">
              <div class="chart-container">
                <canvas id="doughnut" class="doughnut-chart"></canvas>
                <div class="row g-0 chart-text">
                  <span class="events-label">{{ "TOTAL" | translate }}</span>
                  <span class="larger-title">{{
                    totalRemoteCommands | number
                    }}</span>
                </div>
              </div>
            </div>
            <div class="col g-0 assets-color border-allover">
              @for (item of orderedRemoteCommands; track item; let index =
              $index) {
              <div class="row g-0 custom-padding border-bottom">
                <div class="col-auto pe-1 g-0 d-flex justify-content-start align-items-center">
                  <span class="circle" [ngStyle]="{
                      'background-color':
                        chartRemote.data.datasets[0].backgroundColor[index],
                    }"></span>
                  <span class="events-label ps-3">{{
                    item.commandType! | splitCamelCase
                    }}</span>
                </div>
                <div class="col d-flex justify-content-end gap-2">
                  <span class="item-info pe-2 d-flex align-items-center">{{ getSum(item) | number }}</span>
                  <span class="user-label percentage d-flex align-items-center" [ngClass]="{
                      red: (item.success! / getSum(item)) * 100 < 50,
                      green: (item.success! / getSum(item)) * 100 >= 50,
                      neutral: getSum(item) == 0
                    }">
                    {{ getSum(item) !==0 ? ((item.success! / getSum(item) * 100) | number:'1.0-0'): 0 }}%
                  </span>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right part -->
    <div class="col-md-5 member-info p-3 overflow">
      <div class="row pb-3 m-0">
        <div class="col-6">
          <span class="container-title">{{
            "ALARMS&EVENTS" | translate
            }}</span>
        </div>
        <div class="col d-flex justify-content-end">
          <app-date-filter class="w-100" (close)="onDateFilterEvent($event)"></app-date-filter>
        </div>
      </div>
      <div class="row m-0 pb-3">
        <span class="container-title fs-6 pb-3">{{"SIDEBAR_EVENTS" | translate}}</span>
        <div *ngIf="analyticsEvents.length === 0" class="col-12 d-flex justify-content-center align-items-center">
          <span class="events-label">{{ "NO_EVENTS_HAPPENED_IN_PERIOD" | translate }}</span>
        </div>

        <div *ngFor="let item of analyticsEvents; let i = index" class="col-6 mb-3">
          <div
            class="d-flex flex-column justify-content-between container-border ps-3 pe-3 pt-1 pb-1 p-4"
            (click)="navigateToEvents(item.name!)"
            [ngStyle]="getGradientStyle(item.name!)">
            <span class="events-label">{{ item.name! | splitCamelCase }}</span>
            <span class="larger-title">{{ item.count }}</span>
          </div>
        </div>
      <div class="row m-0 pb-3 ps-0">
        <span class="container-title fs-6 pb-3">{{"ALARMS" | translate}}</span>
        <div *ngIf="analyticsAlarms.length === 0" class="col-12 d-flex justify-content-center align-items-center">
          <span class="events-label">{{ "NO_ALARMS_HAPPENED_IN_PERIOD" | translate }}</span>
        </div>

        <div *ngFor="let item of analyticsAlarms; let i = index" class="col-6 mb-3">
          <div
            class="d-flex flex-column justify-content-between container-border gradient ps-3 pe-3 pt-1 pb-1"
            (click)="navigateToAlarms(item.name!)"
            [ngStyle]="getGradientStyle(item.name!)">
            <span class="events-label">{{ item.name! | splitCamelCase }}</span>
            <span class="larger-title">{{ item.count }}</span>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>

  <!-- Online/Offline Activity Chart -->
  <div class="row me-0 pt-4">
    <div class="col-12 member-info p-3 pb-4">
      <div class="row g-0 pb-3 align-items-center title-border">
        <div class="col d-flex align-items-center gap-3">
          <app-dropdown-filter
            [selectedValue]="selectedAssetType"
            [title]="'DEVICESETUP_ASSETTYPE'"
            [items]="assetTypes"
            (close)="onAssetTypeChange($event)">
          </app-dropdown-filter>
        </div>
        <div class="col d-flex justify-content-end align-items-center gap-1">
          <label class="agg-switch" [title]="'AGGREGATE' | translate">
            <input type="checkbox" [checked]="aggregated" (change)="onAggregationToggle()">
            <span class="agg-slider"></span>
            <span class="agg-switch-label">{{ 'AGGREGATE' | translate }}</span>
          </label>
          <button
            *ngFor="let range of timeRanges"
            class="time-range-btn"
            [class.active]="selectedTimeRange === range"
            (click)="onTimeRangeChange(range)">
            {{ range }}
          </button>
          <button
            type="button"
            class="reset-zoom-btn"
            (click)="resetZoom()"
            [title]="'RESET_ZOOM' | translate">
            <i class="bi bi-zoom-out"></i>
          </button>
        </div>
      </div>
      <div class="online-offline-chart-wrapper">
        <canvas id="onlineOfflineChart"></canvas>
      </div>
    </div>
  </div>

</div>
